import React from 'react'
import Lisa from '../../images/Lisa.jpg'

const LisaCuddy = () => (
    <div>
        <img className="profile-pic" src={Lisa} alt="Lisa" />
        <h3>Dr. Lisa Cuddy was a major character on House for the first seven seasons. She was the Dean of Medicine and Chief Hospital Administrator of Princeton-Plainsboro Teaching Hospital from Season 1 to Season 7. She was the direct superior of both Dr. House and Dr. Wilson. She is a specialist in endocrinology, but when in charge, she had a very limited medical practice due to her administrative duties. Dr Cuddy is also frequently referred to by House as a "second rate doctor" or "trollop" due to her lower medical knowledge compared to House and her tendency to dress in low cut tops and tight skirts. House openly Views Lisa as not a real doctor stating "she just assigns parking spaces.</h3>
    </div>
)

export default LisaCuddy
